<template>
  <div>
    <fieldset class="border p-3">
      <legend>
        <small style="font-size:15px; font-weight: bold">new labour charges</small>
      </legend>
      <div>
        <form @submit.prevent="newLabour()">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>
                  Labour date
                  <span class="text-danger">*</span>
                </label>
                <input type="date" class="form-control labour_date input-rounded f-s-14" required />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Description</th>
                      <th scope="col">Truck</th>
                      <th scope="col">Unit</th>
                      <th scope="col">Unit price</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Total</th>
                      <th scope="col">Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(labour_product, k) in LabouritemsRows" :key="k">
                      <td scope="row">
                        <button
                          type="button"
                          class="btn btn-danger"
                          @click="deleteRow(k, labour_product)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                        <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, labour_product)"></i> -->
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="text"
                          v-model="labour_product.labour_description"
                          required
                        />
                      </td>
                      <td>
                        <model-list-select
                          :list="systemTrucks"
                          v-model="labour_product.truck_id"
                          option-value="id"
                          option-text="truck_no"
                          placeholder="select truck name"
                        ></model-list-select>
                      </td>
                      <td>
                        <select
                          name="labour_measurement"
                          class="form-control input_rounded labour_measurement"
                          v-model="labour_product.labour_measurement"
                        >
                          <option value>Select Measurement</option>
                          <option value="KG">KILOGRAMS</option>
                          <option value="PCS">PIECES</option>
                          <option value="LTS">LITRES</option>
                          <option value="SET">SET</option>
                          <option value="PAIR">PAIR</option>
                          <option value="MTR">METRES</option>
                          <option value="N/A">N/A</option>
                        </select>
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="labour_product.unit_price"
                          @change="calculateLineTotal(labour_product)"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="labour_product.qty"
                          @change="calculateLineTotal(labour_product)"
                        />
                      </td>
                    
                      <td>
                        <input
                          readonly
                          class="form-control text-right"
                          type="number"
                          min="0"
                          step=".01"
                          v-model="labour_product.total_price"
                        />
                      </td>
                      <td>
                        <input
                          class="form-control text-right"
                          type="text"
                          v-model="labour_product.remark"
                        />
                      </td>
                    </tr>
                    <tr v-show="LabouritemsRows.length === 0">
                      <td colspan="6">
                        <p class="text-center alert-danger p-2">No products added/available.</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="6" class="text-right">Sub Total</td>
                      <input
                        readonly
                        class="form-control text-right sub_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_subtotal"
                      />
                    </tr>
                    <tr>
                      <td colspan="6" class="text-right">Total</td>
                      <input
                        readonly
                        class="form-control text-right labour_total"
                        type="number"
                        min="0"
                        step=".01"
                        :value="invoice_total"
                      />
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 mb-2">
              <button type="button" class="btn btn-info" @click="addLabourItems">
                <i class="fa fa-plus-circle"></i>
                Add
              </button>
            </div>
            <button type="submit" class="btn btn-primary btn-flat creatingLabour btn-rounded">
              <i class="fa fa-plus"></i> create Labour charge
            </button>
            <button type="button" class="btn-rounded btn-flat creatingLabourLoader btn-rounded">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
            </button>
          </div>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModelListSelect } from "vue-search-select";
import router from "../router/index";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0
    };
  },
  created() {
    this.loadTrucks();
  },
  computed: {
    ...mapGetters(["LabouritemsRows", "systemTrucks"])
  },
  methods: {
    ...mapActions(["newLabour", "loadTrucks"]),
    ...mapMutations(["addLabourItems"]),

    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.LabouritemsRows.reduce(function(sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(labour_product) {
      var total =
        parseFloat(labour_product.unit_price) * parseFloat(labour_product.qty);
      if (!isNaN(total)) {
        labour_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, labour_product) {
      var idx = this.LabouritemsRows.indexOf(labour_product);
      console.log(idx, index);
      if (idx > -1) {
        this.LabouritemsRows.splice(idx, 1);
      }
      this.calculateTotal();
    }
  },
  components: {
    ModelListSelect
  }
};
</script>
<style scoped>
.creatingLabourLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/labour/labour.vue